import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PillButton } from './PillButton';
interface StepNavProps {
  backLabel?: string;
  onBack?: () => void;
  nextLabel?: string;
  onNext?: () => void;
}

/** Quiet chapter navigation: a ghost step back, a small pill forward. */
export function StepNav({
  backLabel,
  onBack,
  nextLabel,
  onNext
}: StepNavProps) {
  return <div className="flex w-full flex-shrink-0 items-center justify-between pt-3" data-id="element-162" data-mp="3o8c4yyqucey8">
      {backLabel && onBack ? <PillButton variant="ghost" onClick={onBack} data-id="element-163" data-mp="3s9fopwc0ev4q">
          <ChevronLeftIcon className="h-3.5 w-3.5" data-id="element-164" data-mp="3eaocygkmdljr" />
          {backLabel}
        </PillButton> : <span data-id="element-165" data-mp="3j9snbaja5pbo" />}

      {nextLabel && onNext ? <PillButton variant="outline" onClick={onNext} data-id="element-166" data-mp="3j87q1d5kzsa4">
          {nextLabel}
          <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-167" data-mp="22uhi1vbccjv7" />
        </PillButton> : <span data-id="element-168" data-mp="27uvsfk0f05we" />}
    </div>;
}